import convertCoach from './coach'
import convertCoachee from './coachee'
import config from '@/config'

const profile = {
  [config.groups.ADMIN]: () => {},
  [config.groups.COACH]: user => convertCoach(user),
  [config.groups.COACHEE]: user => convertCoachee(user)
}

/**
 * Convert data from user API to internal format
 * @param {Object} user User API data
 * @returns {Object} Converted user data
 */
export default function (user) {
  const meta = {
    id: user.user.id,
    isConfirmed: user.user && user.user.email_confirmed,
    isApproved: user.approved
  }

  // Barebones user data for new users
  if (user.new_user) {
    return {
      meta: { ...meta, group: config.groups.NEW },
      profile: {}
    }
  }

  // Barebeones user data for user with missing group
  // This is an edge-case and shouldn’t happen in normal use.
  // But in case someone creates a user and forgets to assign a group,
  // we want to be prepared.
  if (!user.user.groups.length) {
    return {
      meta: { ...meta, group: false },
      profile: {}
    }
  }

  const group = user.user.groups[0].name.toLowerCase()

  return {
    meta: {
      ...meta,
      group,
      username: user.user.username,
      joined: new Date(user.user.date_joined),
      lastLogin: new Date(user.user.last_login)
    },
    profile: {
      ...profile[group](user),
      id: user.id,
      name: `${user.user.first_name} ${user.user.last_name}`,
      firstName: user.user.first_name,
      lastName: user.user.last_name,
      email: user.user.email
    }
  }
}
